import { useState } from "react";
import { Editor } from "@tiptap/react";
import InsertLinkIcon from "@mui/icons-material/InsertLink";
import {
  TextField,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import { ToggleButton } from "@mui/material";
import { SvgIcon } from "@mui/material";
import { styled } from "@mui/material/styles";

interface MenuButtonLinkProps {
  editor: Editor;
}

const PlainIconButton = styled(ToggleButton)(({ theme }) => ({
  border: 0,
  background: "none",
  boxShadow: "none",
  minWidth: 0,
  padding: 4,
  borderRadius: 4,
  "&.Mui-selected": {
    background: "none",
    color: theme.palette.primary.main,
  },
  "&:hover": {
    background: "none",
    color: theme.palette.text.primary,
  },
}));

export function MenuButtonLink({ editor }: MenuButtonLinkProps) {
  const [open, setOpen] = useState(false);
  const [url, setUrl] = useState("");

  const handleInsertLink = () => {
    if (url) {
      editor.chain().focus().setLink({ href: url }).run();
    }
    setOpen(false);
  };

  return (
    <>
      <PlainIconButton value="link" onClick={() => setOpen(true)}>
        <SvgIcon fontSize="small">
          <InsertLinkIcon />
        </SvgIcon>
      </PlainIconButton>
      <Dialog open={open} onClose={() => setOpen(false)}>
        <DialogTitle>Inserir Link</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            label="URL"
            type="url"
            fullWidth
            variant="outlined"
            value={url}
            onChange={(e) => setUrl(e.target.value)}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)}>Cancelar</Button>
          <Button onClick={handleInsertLink} color="primary">
            Inserir
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
